import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Divider,
  Alert,
  Tooltip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Snackbar,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  PlayArrow as PlayIcon,
  Pause as PauseIcon,
  AutoAwesome as AutomationIcon,
  Schedule as ScheduleIcon,
  Message as MessageIcon,
  Person as PersonIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import AutomationService from "../services/AutomationService";

const AutomationView = ({ onNavigateToFlow }) => {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [selectedAutomation, setSelectedAutomation] = useState(null);
  const [activeTab, setActiveTab] = useState("keyword-actions");

  // Add Keyword Action Dialog State
  const [isAddKeywordDialogOpen, setIsAddKeywordDialogOpen] = useState(false);
  const [keywordAction, setKeywordAction] = useState({
    keyword: "",
    chatbot: "",
    chatbotId: null,
  });
  const [keywordActionErrors, setKeywordActionErrors] = useState({});
  const [automations, setAutomation] = useState([]);

  // Mock chatbots data
  // const [chatbots, setChatbots] = useState([
  //   { id: "chatbot1", name: "Customer Support Bot" },
  //   { id: "chatbot2", name: "Sales Assistant Bot" },
  //   { id: "chatbot3", name: "FAQ Bot" },
  //   { id: "chatbot4", name: "Order Tracking Bot" },
  // ]);

  const [chatbots, setChatbots] = useState([])

  // Create Chatbot Dialog State
  const [isCreateChatbotDialogOpen, setIsCreateChatbotDialogOpen] =
    useState(false);
  const [newChatbot, setNewChatbot] = useState({
    name: "",
  });
  const [chatbotErrors, setChatbotErrors] = useState({});

  // Mock keyword actions data
  // const [keywordActions, setKeywordActions] = useState([
  //   {
  //     id: 1,
  //     keyword: "Hi",
  //     triggered: 45,
  //     matchingMethod: "Exact",
  //     replyMaterial: "Welcome message",
  //     chatbot: "Customer Support Bot",
  //   },
  //   {
  //     id: 2,
  //     keyword: "Help",
  //     triggered: 23,
  //     matchingMethod: "Contains",
  //     replyMaterial: "Help guide",
  //     chatbot: "FAQ Bot",
  //   },
  // ]);
  const [keywordActions, setKeywordActions] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  function fetch() {
    AutomationService.getChatBot().then((r) => {
      console.log('r', r);
      
      setAutomation(r);
      const formatted = r.map((res) => ({
        id: res.getId(),
        name: res.getTemplateName(),
        status: res.getStatus(),
        trigger: res.getTrigger(),
        description: res.getDescription(),
        action: res.getAction(),
        contacts: res.getContacts(),
        lastRun: res.getLastRun(),
        nextRun: res.getNextRun(),
      }));
  
      setChatbots(formatted);
    });
    AutomationService.getKeyWords().then((res) => {
      const formatRows = res.map((res) => ({
        id: res.getId(),
        keyword: res.getKeyword(),
        triggered: res.getTriggerNo(),
        matchingMethod: res.getMatchMethod(),
        replyMaterial: res.getReplyMaterial(),
        chatbot: res.getChatbotName(),
        chatbotId: res.getChatbotId(),
        templateId: res.getTemplateId(),
      }));
      setKeywordActions(formatRows);
    })
  }

  useEffect(() => {
    fetch();
  }, [])
  // Mock data for automation workflows
  // const automations = [
  //   {
  //     id: 1,
  //     name: "Welcome Message",
  //     description: "Send welcome message to new contacts",
  //     trigger: "New Contact",
  //     action: "Send Message",
  //     status: "active",
  //     contacts: 45,
  //     lastRun: "2 hours ago",
  //     nextRun: "In 5 minutes",
  //   },
  //   {
  //     id: 2,
  //     name: "Follow-up Sequence",
  //     description: "3-day follow-up sequence for leads",
  //     trigger: "Tag Added",
  //     action: "Message Sequence",
  //     status: "active",
  //     contacts: 23,
  //     lastRun: "1 day ago",
  //     nextRun: "Tomorrow",
  //   },
  //   {
  //     id: 3,
  //     name: "Birthday Wishes",
  //     description: "Send birthday wishes to contacts",
  //     trigger: "Date",
  //     action: "Send Message",
  //     status: "paused",
  //     contacts: 12,
  //     lastRun: "3 days ago",
  //     nextRun: "Next month",
  //   },
  //   {
  //     id: 4,
  //     name: "Abandoned Cart",
  //     description: "Remind customers about abandoned cart",
  //     trigger: "Event",
  //     action: "Send Message",
  //     status: "active",
  //     contacts: 8,
  //     lastRun: "6 hours ago",
  //     nextRun: "In 2 hours",
  //   },
  // ];

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "success";
      case "paused":
        return "warning";
      case "draft":
        return "default";
      default:
        return "default";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "active":
        return <PlayIcon fontSize="small" />;
      case "paused":
        return <PauseIcon fontSize="small" />;
      default:
        return <SettingsIcon fontSize="small" />;
    }
  };

  // const handleCreateAutomation = () => {
  //   console.log("Create Automation button clicked");
  //   if (onNavigateToFlow) {
  //     console.log("Navigating to Flow screen");
  //     onNavigateToFlow();
  //   } else {
  //     console.log("Opening create dialog (fallback)");
  //     setIsCreateDialogOpen(true);
  //   }
  // };
  const handleEditAutomation = (automation) => {
    console.log("Edit Automation button clicked for:", automation);
    if (onNavigateToFlow) {
      console.log("Navigating to Flow screen for editing");
      onNavigateToFlow(automation.getId());
    } else {
      console.log("Opening edit dialog (fallback)");
      setSelectedAutomation(automation);
      setIsCreateDialogOpen(true);
    }
  };

  async function handleDeleteAutomation(automation) {
    try {
      await AutomationService.deleteChatbot(automation.getId());
      setSnackbar({
        open: true,
        message: 'Chatbot deleted successfully!',
        severity: "success",
      });
      fetch(false);
    } catch (error) {
      console.log('Chatbot Delete Error:', error);
      setSnackbar({
        open: true,
        message: 'Chatbot not deleted!',
        severity: "error",
      });
    }
    // Handle delete logic
    console.log("Delete automation:", automation.getId());
  };

  const handleToggleStatus = (automation) => {
    // Handle status toggle logic
    console.log("Toggle status for:", automation.id);
  };

  // Add Keyword Action Dialog Handlers
  const handleOpenAddKeywordDialog = () => {
    setIsAddKeywordDialogOpen(true);
    setKeywordAction({ keyword: "", chatbot: "", chatbotId: null });
    setKeywordActionErrors({});
  };

  const handleCloseAddKeywordDialog = () => {
    setIsAddKeywordDialogOpen(false);
    setKeywordAction({ keyword: "", chatbot: "", chatbotId: null });
    setKeywordActionErrors({});
  };

  const handleKeywordActionChange = (field, value, id) => {
    setKeywordAction((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (keywordActionErrors[field]) {
      setKeywordActionErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateKeywordAction = () => {
    const errors = {};

    if (!keywordAction.keyword.trim()) {
      errors.keyword = "Keyword is required";
    }

    if (!keywordAction.chatbot) {
      errors.chatbot = "Please select a chatbot";
    }

    setKeywordActionErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function handleSaveKeywordAction() {
    if (validateKeywordAction()) {
      const existing = keywordActions.find(
        (item) => item.chatbotId === keywordAction.chatbotId
      );
      console.log('existing', existing);
      console.log('keywordActions', keywordActions);
      
      const newKeywordAction = {
        chatbotId: keywordAction.chatbotId,
        templateId: existing?.templateId || null,
        keyword: keywordAction.keyword.trim(),
        triggered: 0,
        matchingMethod: "Exact",
        replyMaterial: "Auto-reply",
        chatbot: keywordAction.chatbot,
      };

      setKeywordActions((prev) => [...prev, newKeywordAction]);
      fetch(false);
      try {
      await AutomationService.saveKeyWordAction(newKeywordAction);
      setSnackbar({
        open: true,
        message: 'Keyword saved successfully!',
        severity: "success",
      });
      } catch (error) {
        console.log('Keyword Save Error:', error);
        setSnackbar({
          open: true,
          message: 'Keyword not saved!',
          severity: "error",
        });
      }
      handleCloseAddKeywordDialog();

      // Show success message (you can add a snackbar here)
      console.log("Keyword action saved:", newKeywordAction);
    }
  };

  function snackBar() {
    return (
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    )
  }

  // Create Chatbot Dialog Handlers
  const handleOpenCreateChatbotDialog = () => {
    setIsCreateChatbotDialogOpen(true);
    setNewChatbot({ name: "" });
    setChatbotErrors({});
  };

  const handleCloseCreateChatbotDialog = () => {
    setIsCreateChatbotDialogOpen(false);
    setNewChatbot({ name: "" });
    setChatbotErrors({});
  };

  const handleChatbotNameChange = (value) => {
    setNewChatbot((prev) => ({
      ...prev,
      name: value,
    }));

    // Clear error when user starts typing
    if (chatbotErrors.name) {
      setChatbotErrors((prev) => ({
        ...prev,
        name: "",
      }));
    }
  };

  const validateChatbot = () => {
    const errors = {};

    if (!newChatbot.name.trim()) {
      errors.name = "Chatbot name is required";
    }

    // Check for duplicate names
    const isDuplicate = chatbots.some(
      (chatbot) =>
        chatbot.name.toLowerCase() === newChatbot.name.trim().toLowerCase()
    );

    if (isDuplicate) {
      errors.name = "A chatbot with this name already exists";
    }

    setChatbotErrors(errors);
    return Object.keys(errors).length === 0;
  };

    async function handleCreateChatbot() {
    if (validateChatbot()) {
      const newChatbotData = {
        id: null,
        name: newChatbot.name.trim(),
        description: "3-day follow-up sequence for leads",
        trigger: "Tag Added",
        action: "Message Sequence",
        status: "active",

      };
      // const newChat = {
      //   id: null,
      //   name: newChatbot.name.trim(),
      // }
      setNewChatbot((prev) => ({
        ...prev, newChatbotData }));
      try {
        await AutomationService.createChatBot(newChatbotData);
        setSnackbar({
          open: true,
          message: 'Chatbot created successfully!',
          severity: "success",
        });
        fetch(false);
      } catch (error) {
        setSnackbar({
          open: true,
          message: 'Chatbot not saved!',
          severity: "error",
        });
        console.log('Chatbot Error:', error);
        
      }
      handleCloseCreateChatbotDialog();

      // Show success message (you can add a snackbar here)
      console.log("Chatbot created:", newChatbotData);
    }
  };

  return (
    <Box sx={{ height: "100%", display: "flex" }}>
      {/* Left Sidebar */}
      <Box
        sx={{
          width: 280,
          background: "#ffffff",
          borderRight: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: "column",
          flexShrink: 0,
        }}
      >
        {/* Automation Navigation */}
        <Box
          sx={{
            padding: "24px 20px 20px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              marginBottom: "16px",
              color: "#1a1a1a",
              fontSize: "16px",
              fontWeight: "600",
              letterSpacing: "0.5px",
            }}
          >
            Automation
          </Typography>

          {/* Navigation Items */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {/* Keyword Actions */}
            <Box
              onClick={() => setActiveTab("keyword-actions")}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px 16px",
                borderRadius: "8px",
                cursor: "pointer",
                backgroundColor:
                  activeTab === "keyword-actions" ? "#f8f9ff" : "#ffffff",
                border: `1px solid ${
                  activeTab === "keyword-actions" ? "#e3e6ff" : "#e0e0e0"
                }`,
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor:
                    activeTab === "keyword-actions" ? "#f0f2ff" : "#f8f9fa",
                  borderColor:
                    activeTab === "keyword-actions" ? "#d1d5ff" : "#d0d0d0",
                },
              }}
            >
              <Typography
                sx={{
                  color:
                    activeTab === "keyword-actions" ? "#4f46e5" : "#6b7280",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Keyword Actions
              </Typography>
            </Box>

            {/* Chatbots */}
            <Box
              onClick={() => setActiveTab("chatbots")}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px 16px",
                borderRadius: "8px",
                cursor: "pointer",
                backgroundColor:
                  activeTab === "chatbots" ? "#f8f9ff" : "#ffffff",
                border: `1px solid ${
                  activeTab === "chatbots" ? "#e3e6ff" : "#e0e0e0"
                }`,
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor:
                    activeTab === "chatbots" ? "#f0f2ff" : "#f8f9fa",
                  borderColor: activeTab === "chatbots" ? "#d1d5ff" : "#d0d0d0",
                },
              }}
            >
              <Typography
                sx={{
                  color: activeTab === "chatbots" ? "#4f46e5" : "#6b7280",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Chatbots
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          p: activeTab === "keyword-actions" ? 2 : 3,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: activeTab === "keyword-actions" ? 2 : 3,
            pb: 2,
            borderBottom:
              activeTab !== "keyword-actions" ? "1px solid #e0e0e0" : "none",
          }}
        >
          {activeTab !== "keyword-actions" && (
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <AutomationIcon sx={{ color: "#1976d2", fontSize: 28 }} />
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 600, color: "#1976d2" }}
                >
                  Chatbots
                </Typography>
              </Box>
              <Tooltip title="Create a new chatbot">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleOpenCreateChatbotDialog}
                  sx={{
                    backgroundColor: "#1976d2",
                    "&:hover": { backgroundColor: "#1565c0" },
                    borderRadius: 2,
                    px: 3,
                    py: 1,
                  }}
                >
                  Create Chatbot
                </Button>
              </Tooltip>
            </>
          )}
        </Box>

        {/* Stats Cards - Only show when not in keyword-actions or chatbots tabs */}
        {activeTab !== "keyword-actions" && activeTab !== "chatbots" && (
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{ borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <AutomationIcon sx={{ color: "#1976d2" }} />
                    </Box>
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: 600 }}>
                        {automations.length}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Total Workflows
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{ borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        backgroundColor: "#e8f5e8",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PlayIcon sx={{ color: "#4caf50" }} />
                    </Box>
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: 600 }}>
                        {
                          automations.filter((a) => a.getStatus() === "active")
                            .length
                        }
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Active Workflows
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{ borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        backgroundColor: "#fff3e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PauseIcon sx={{ color: "#ff9800" }} />
                    </Box>
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: 600 }}>
                        {
                          automations.filter((a) => a.getStatus() === "paused")
                            .length
                        }
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Paused Workflows
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{ borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        backgroundColor: "#f3e5f5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PersonIcon sx={{ color: "#9c27b0" }} />
                    </Box>
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: 600 }}>
                        {automations.reduce(
                          (total, a) => total + a.contacts,
                          0
                        )}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Total Contacts
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}

        {/* Conditional Content Based on Active Tab */}
        {activeTab === "keyword-actions" && (
          <Box sx={{ mb: 4 }}>
            {/* Header Section */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{ mb: 2, color: "#1a1a1a", fontWeight: 600 }}
              >
                Add Keyword Action List
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 4, fontSize: "14px" }}
              >
                When the message matches the keyword, automatically reply.
              </Typography>

              {/* Action Bar */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 4,
                  gap: 3,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flex: 1,
                    maxWidth: 400,
                  }}
                >
                  <TextField
                    placeholder="Search..."
                    size="small"
                    sx={{
                      flex: 1,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "#f8f9fa",
                        height: "40px",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <Box sx={{ mr: 1, color: "#6b7280", fontSize: "16px" }}>
                          🔍
                        </Box>
                      ),
                    }}
                  />
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="contained"
                    onClick={handleOpenAddKeywordDialog}
                    sx={{
                      backgroundColor: "#1976d2",
                      "&:hover": { backgroundColor: "#1565c0" },
                      borderRadius: 2,
                      px: 3,
                      py: 1.5,
                      textTransform: "none",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Add keyword action
                  </Button>
                </Box>
              </Box>
            </Box>

            {/* Keyword Actions Table */}
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
            >
              <Box sx={{ overflowX: "auto" }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          color: "#374151",
                          fontSize: "14px",
                          py: 2.5,
                          px: 3,
                        }}
                      >
                        Keyword
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          color: "#374151",
                          fontSize: "14px",
                          py: 2.5,
                          px: 3,
                        }}
                      >
                        Triggered
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          color: "#374151",
                          fontSize: "14px",
                          py: 2.5,
                          px: 3,
                        }}
                      >
                        Matching method
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          color: "#374151",
                          fontSize: "14px",
                          py: 2.5,
                          px: 3,
                        }}
                      >
                        Reply material
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          color: "#374151",
                          fontSize: "14px",
                          py: 2.5,
                          px: 3,
                        }}
                      >
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {keywordActions.map((action) => (
                      <TableRow
                        key={action.id}
                        sx={{
                          "&:hover": { backgroundColor: "#f8f9fa" },
                          "&:last-child td": { border: 0 },
                        }}
                      >
                        <TableCell sx={{ py: 2.5, px: 3 }}>
                          <Chip
                            label={action.keyword}
                            size="small"
                            sx={{
                              backgroundColor: "#e5e7eb",
                              color: "#6b7280",
                              fontWeight: 500,
                              fontSize: "12px",
                              height: "24px",
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 2.5, px: 3 }}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            {action.triggered}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 2.5, px: 3 }}>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: "13px" }}
                          >
                            {action.matchingMethod}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 2.5, px: 3 }}>
                          <Chip
                            label={action.replyMaterial}
                            size="small"
                            sx={{
                              backgroundColor: "#fff3e0",
                              color: "#f57c00",
                              fontWeight: 500,
                              fontSize: "12px",
                              height: "24px",
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 2.5, px: 3 }}>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <IconButton
                              size="small"
                              sx={{
                                color: "#1976d2",
                                "&:hover": { backgroundColor: "#e3f2fd" },
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              sx={{
                                color: "#f44336",
                                "&:hover": { backgroundColor: "#ffebee" },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Card>
          </Box>
        )}

        {activeTab === "chatbots" && (
          <Box sx={{ mb: 3 }}>
            {/* Chatbots content removed - only Active Workflows will show */}
          </Box>
        )}

        {/* Automation Workflows - Only show when not in keyword-actions tab */}
        {activeTab !== "keyword-actions" && (
          <>
            <Grid container spacing={3}>
              {automations.map((automation) => (
                <Grid item xs={12} md={6} lg={4} key={automation.getId()}>
                  <Card
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CardContent sx={{ flex: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          mb: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {automation.getTemplateName()}
                        </Typography>
                        <Chip
                          icon={getStatusIcon(automation.getStatus())}
                          label={automation.getStatus()}
                          color={getStatusColor(automation.getStatus())}
                          size="small"
                        />
                      </Box>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        {automation.getDescription()}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <ScheduleIcon sx={{ fontSize: 16, color: "#666" }} />
                          <Typography variant="body2" color="text.secondary">
                            Trigger: {automation.getTrigger()}
                          </Typography>
                        </Box>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <MessageIcon sx={{ fontSize: 16, color: "#666" }} />
                          <Typography variant="body2" color="text.secondary">
                            Action: {automation.getAction()}
                          </Typography>
                        </Box>
                      </Box>

                      <Divider sx={{ my: 2 }} />

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box>
                          <Typography variant="body2" color="text.secondary">
                            {automation.getContacts()} contacts
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Last run: {automation.getLastRun()}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            Next: {automation.getNextRun()}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>

                    <CardActions sx={{ p: 2, pt: 0 }}>
                      <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
                        <Tooltip title="Open Visual Flow Builder to edit automation">
                          <IconButton
                            size="small"
                            onClick={() => handleEditAutomation(automation)}
                            sx={{ color: "#1976d2" }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title={
                            automation.status === "active"
                              ? "Pause"
                              : "Activate"
                          }
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleToggleStatus(automation)}
                            sx={{
                              color:
                                automation.status === "active"
                                  ? "#ff9800"
                                  : "#4caf50",
                            }}
                          >
                            {automation.status === "active" ? (
                              <PauseIcon fontSize="small" />
                            ) : (
                              <PlayIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Automation">
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteAutomation(automation)}
                            sx={{ color: "#f44336" }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Box>

      {/* Create/Edit Automation Dialog */}
      <Dialog
        open={isCreateDialogOpen}
        onClose={() => {
          setIsCreateDialogOpen(false);
          setSelectedAutomation(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          },
        }}
      >
        <DialogTitle>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AutomationIcon sx={{ color: "#1976d2" }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {selectedAutomation ? "Edit Automation" : "Create New Automation"}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <TextField
              label="Automation Name"
              placeholder="Enter automation name"
              fullWidth
              defaultValue={selectedAutomation?.name || ""}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <TextField
              label="Description"
              placeholder="Describe what this automation does"
              multiline
              rows={3}
              fullWidth
              defaultValue={selectedAutomation?.description || ""}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <FormControl fullWidth>
              <InputLabel>Trigger Type</InputLabel>
              <Select
                label="Trigger Type"
                defaultValue={selectedAutomation?.trigger || ""}
                sx={{
                  borderRadius: 2,
                }}
              >
                <MenuItem value="New Contact">New Contact</MenuItem>
                <MenuItem value="Tag Added">Tag Added</MenuItem>
                <MenuItem value="Date">Date</MenuItem>
                <MenuItem value="Event">Event</MenuItem>
                <MenuItem value="Message Received">Message Received</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Action Type</InputLabel>
              <Select
                label="Action Type"
                defaultValue={selectedAutomation?.action || ""}
                sx={{
                  borderRadius: 2,
                }}
              >
                <MenuItem value="Send Message">Send Message</MenuItem>
                <MenuItem value="Message Sequence">Message Sequence</MenuItem>
                <MenuItem value="Add Tag">Add Tag</MenuItem>
                <MenuItem value="Remove Tag">Remove Tag</MenuItem>
                <MenuItem value="Update Contact">Update Contact</MenuItem>
              </Select>
            </FormControl>

            <FormControlLabel
              control={
                <Switch
                  defaultChecked={selectedAutomation?.status === "active"}
                />
              }
              label="Activate automation immediately"
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button
            onClick={() => {
              setIsCreateDialogOpen(false);
              setSelectedAutomation(null);
            }}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
            }}
          >
            {selectedAutomation ? "Update Automation" : "Create Automation"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Keyword Action Dialog */}
      <Dialog
        open={isAddKeywordDialogOpen}
        onClose={handleCloseAddKeywordDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            fontSize: "20px",
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          Add Keyword Action
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <TextField
              label="Keyword"
              placeholder="Enter keyword (e.g., 'help', 'pricing')"
              fullWidth
              value={keywordAction.keyword}
              onChange={(e) =>
                handleKeywordActionChange("keyword", e.target.value)
              }
              error={!!keywordActionErrors.keyword}
              helperText={keywordActionErrors.keyword}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <FormControl fullWidth error={!!keywordActionErrors.chatbot}>
              <InputLabel>Select Chatbot</InputLabel>
              <Select
                label="Select Chatbot"
                value={keywordAction.chatbot}
                onChange={(e) => {
                  console.log('eeee', e);
                  
                  handleKeywordActionChange("chatbot", e.target.value);
                }}
                sx={{
                  borderRadius: 2,
                }}
              >
                {chatbots.map((chatbot) => (
                  <MenuItem key={chatbot.id} value={chatbot.name} onClick={() =>  handleKeywordActionChange("chatbotId", chatbot.id)}>
                    {chatbot.name}
                  </MenuItem>
                ))}
              </Select>
              {keywordActionErrors.chatbot && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, ml: 1.5 }}
                >
                  {keywordActionErrors.chatbot}
                </Typography>
              )}
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button
            onClick={handleCloseAddKeywordDialog}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveKeywordAction}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create Chatbot Dialog */}
      <Dialog
        open={isCreateChatbotDialogOpen}
        onClose={handleCloseCreateChatbotDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            fontSize: "20px",
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          Create Chatbot
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <TextField
              label="Chatbot Name"
              placeholder="Enter chatbot name (e.g., 'Customer Support Bot')"
              fullWidth
              value={newChatbot.name}
              onChange={(e) => handleChatbotNameChange(e.target.value)}
              error={!!chatbotErrors.name}
              helperText={chatbotErrors.name}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button
            onClick={handleCloseCreateChatbotDialog}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleCreateChatbot}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {snackBar()}
    </Box>
  );
};

export default AutomationView;
